import { render, staticRenderFns } from "./AddFilterDialog.vue?vue&type=template&id=0a4d4f44&scoped=true"
import script from "./AddFilterDialog.vue?vue&type=script&lang=js"
export * from "./AddFilterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d4f44",
  null
  
)

export default component.exports